import {
    HOLE_CREATE_REQUEST, HOLE_CREATE_SUCCESS, HOLE_CREATE_FAIL, HOLE_CREATE_RESET,
    HOLE_UPDATE_REQUEST, HOLE_UPDATE_SUCCESS, HOLE_UPDATE_FAIL, HOLE_UPDATE_RESET,
    HOLE_DELETE_REQUEST, HOLE_DELETE_SUCCESS, HOLE_DELETE_FAIL,
} from '../constants/holeConstants'

export const holeCreateReducer = (state = {}, action) => {
    switch (action.type) {
        case HOLE_CREATE_REQUEST: return { loading: true }
        case HOLE_CREATE_SUCCESS: return { loading: false, success: true, hole: action.payload }
        case HOLE_CREATE_FAIL:    return { loading: false, error: action.payload }
        case HOLE_CREATE_RESET:   return {}
        default: return state
    }
}

export const holeUpdateReducer = (state = {}, action) => {
    switch (action.type) {
        case HOLE_UPDATE_REQUEST: return { loading: true }
        case HOLE_UPDATE_SUCCESS: return { loading: false, success: true, hole: action.payload }
        case HOLE_UPDATE_FAIL:    return { loading: false, error: action.payload }
        case HOLE_UPDATE_RESET:   return {}
        default: return state
    }
}

export const holeDeleteReducer = (state = {}, action) => {
    switch (action.type) {
        case HOLE_DELETE_REQUEST: return { loading: true }
        case HOLE_DELETE_SUCCESS: return { loading: false, success: true }
        case HOLE_DELETE_FAIL:    return { loading: false, error: action.payload }
        default: return state
    }
}
